import { css } from 'aphrodite';
import { useParams } from 'react-router-dom';
import { useAdminAccountQuery } from '../../../queries/Admin/Account/useAdminAccountQuery';
import { styleSheet } from './styles';

export function AccountDetailsTabContentOverview() {
	const { accountId } = useParams<{ accountId: string }>();
	const accountQuery = useAdminAccountQuery({ accountId });

	if (!accountQuery.isSuccess) {
		return <div className={css(styleSheet.placeholderContent)}>Loading...</div>;
	}

	return (
		<div className={css(styleSheet.placeholderContent)}>
			Account Details Overview for {accountQuery.data?.companyName}
		</div>
	);
}
